const model = {
  kyc: {
    retrieved: false,
    loading: true,
    widgets: null,
    sources: null,
    error: false,
    options: null,
  },
  programs: {
    retrieved: false,
    loading: true,
    widgets: null,
    sources: null,
    error: false,
    options: null,
  },
  amp: {
    retrieved: false,
    loading: true,
    widgets: null,
    sources: null,
    error: false,
    options: null,
  },
  dd: {
    retrieved: false,
    loading: true,
    widgets: null,
    sources: null,
    error: false,
    options: null,
  },
  scp: {
    retrieved: false,
    loading: true,
    widgets: null,
    sources: null,
    source: null,
    error: false,
    options: null,
  },
  scl: {
    retrieved: false,
    loading: true,
    widgets: null,
    sources: null,
    source: null,
    error: false,
    options: null,
  },
  'mine-operators': {
    retrieved: false,
    loading: true,
    widgets: null,
    sources: null,
    source: null,
    error: false,
    options: null,
  },
};

export default model;
